import * as buttons from 'smg/buttons';
import * as contact from 'smg/customer-api/contact';
import * as session from 'smg/customer-api/session';
import Modal from 'smg/modal';
import { Phone } from 'smg/phone';
import * as uploads from 'smg/uploads';
import { Relref } from '../hugo';

void main();

async function main() {
    const firstName = document.querySelector('#firstName') as HTMLInputElement;
    const lastName = document.querySelector('#lastName') as HTMLInputElement;
    const company = document.querySelector('#company') as HTMLInputElement;
    const email = document.querySelector('#email') as HTMLInputElement;
    const message = document.querySelector('#message') as HTMLTextAreaElement;
    const phone = document.querySelector('#phone') as HTMLInputElement;
    const form = document.querySelector('#form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const confirm = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const uploadsLabel = form.querySelector('#uploads') as HTMLLabelElement;
    const preferSMS = document.querySelector<HTMLInputElement>('#sms-opt-in');

    const p = new Phone(phone);

    try {
        const user = await session.Session().then(s => s.user);
        firstName.value = user.firstName ?? '';
        lastName.value = user.lastName ?? '';
        email.value = user.emailAddress.email;
        void p.ready().then(() =>
            p.iti.setNumber(user.phoneNumber.phone));
        company.value = user.company ?? '';
    } catch (err) {
        // ignore
    }

    const u = new uploads.Uploader(uploadsLabel, {
        confirmBtn: confirm,
        thumbnails: document.querySelector('#uploads-thumbnails') as HTMLElement,
    });

    form?.addEventListener('submit', async e => {
        e.preventDefault();

        const name: string = `${firstName.value} ${lastName.value}`;
        fieldset.setAttribute('disabled', '');
        buttons.Start(confirm);

        const contactData: contact.CreateContactOpts = {
            name: name,
            company: company.value,
            phone: p,
            email: email.value,
            content: message.value,
            uploader: u,
            preferSMS: preferSMS?.checked,
            $reCaptchaPlaceholder: form.querySelector('.contact-recpatcha-parent') as HTMLElement,
        };

        try {
            await contact.CreateContact(contactData);

            const contactName: string = firstName.value;

            window.sessionStorage.setItem('name', contactName);
            window.location.href = Relref('/contact-success');
        } catch (err) {
            fieldset.removeAttribute('disabled');
            buttons.Stop(confirm);

            if (err !== contact.ReCaptchaError) {
                new Modal({
                    title: 'Oops! Something went wrong',
                    text: String(err),
                });
            }

            throw err;
        }
    });
}